<template>
  <client-only>
    <div>
      <OtpDialog />
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        nudge-left="125%"
        nudge-top="-15px"
        offset-y
        content-class="login-menu-wrapper"
        id="login-menu"
      >
        <template #activator="{ on }">
          <v-btn
            text
            class="login-btn px-1"
            v-on="on"
            :class="{ isOpen: menu }"
          >
            <span class="user-icon"></span>
            <span class="d-block btn-text login-text">{{ iconText }}</span>
          </v-btn>
        </template>

        <v-card class="login-menu-hdr" :outlined="false">
          <v-layout justify-center wrap align-baseline mt-2 mb-1>
            <v-flex xs12 v-show="isLogged">
              <p class="display-16 black--text">
                <strong>{{ welcomeText }}</strong>
              </p>
            </v-flex>
            <v-flex>
              <p class="display-18 font-weight-medium mr-2" v-if="!isLogged">
                {{ Popover.title }}
              </p>
              <!-- to="/personal/myboard.aspx" -->
              <nuxt-link :to="myBoardUrl" v-if="isLogged" class="black--text">
                <p class="display-18 font-weight-medium mr-2">
                  {{ Popover.titleLogged }}
                </p>
              </nuxt-link>
            </v-flex>
            <v-flex text-left>
              <v-btn
                text
                class="pa-0 ml-2 font-weight-medium display-18 h-auto"
                @click="menu = false"
              >
                X
              </v-btn>
            </v-flex>
          </v-layout>
          <div class="hdr-border mb-2"></div>

          <v-card-actions v-if="!isLogged" id="login-box">
            <v-container pa-0>
              <v-layout wrap justify-space-around>
                <v-btn
                  outlined
                  large
                  class="looking-btn"
                  :class="{ 'selected-looking': showStar }"
                  @click="
                    showStar = !showStar;
                    showStar2 = false;
                    showStar3 = false;
                  "
                >
                  {{ Popover.userBtnTxt }}
                </v-btn>
                <v-btn
                  outlined
                  large
                  class="ma-0 recruiter-btn"
                  :class="{ 'selected-recruiter': showStar2 }"
                  :href="adminUrl"
                  target="_self"
                >
                  {{ Popover.recruiterBtnTxt }}
                </v-btn>
              </v-layout>

              <div v-show="showStar">
                <FormLogin :activateOtpOnPage="true" />
                <p
                  class="not-register text-center black--text"
                  @click="
                    showStar3 = !showStar3;
                    showStar = false;
                    showStar2 = false;
                  "
                >


                  לא רשום?
                  <span class="pointer-underline pt-2">להרשמה מהירה</span>
                </p>
              </div>

              <div v-show="showStar2">
                <a :href="adminUrl" target="_self">
                  <p class="display-18 text-center mt-5">הרשמה</p>
                </a>
              </div>

              <!-- sign up form  -->
              <div v-show="showStar3">
                <p class="mt-3 mb-1 underline font-weight-medium">הרשמה</p>

                <FormSignup :page="'1'" :activateOtpOnPage="true" @close-menu="closeMenu"/>
              </div>
            </v-container>
          </v-card-actions>

          <v-layout column wrap v-show="isLogged" class="logged-in-menu">
            <v-flex
              xs12
              mb-2
              v-for="(item, index) in Popover.userLoggedinMenu"
              :key="index"
            >
              <v-icon d-inline-flex class="v-align-middle">
                mdi-chevron-left
              </v-icon>

              <nuxt-link
                v-if="index === 0"
                :to="myBoardUrl"
                target="_self"
                :prefetch="false"
                class="display-16 d-inline-flex black--text no-underline"
              >
                {{ item.value }}
              </nuxt-link>

              <nuxt-link
                v-if="index !== 0"
                :to="index === 4 ? smartLink : item.link"
                target="_self"
                :prefetch="false"
                class="display-16 d-inline-flex black--text no-underline"
              >

                <span  v-if="index !== 4">{{ item.value }}</span>
                <span  v-else>הסוכנת החכמה</span>
              </nuxt-link>
            </v-flex>

            <v-flex xs12 class="border-none">
              <p
                @click="logout()"
                class="pointer d-inline-flex link-plain display-16"
                id="logout-btn"
              >
                התנתק
              </p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-menu>
    </div>
  </client-only>
</template>


<script>
/**
 *  @todo - large template - split it
 */

import { mapActions } from 'vuex';

import FormLogin from '@/components/NavigationMenu/UserMenu/FormLogin';
import FormSignup from '@/components/NavigationMenu/UserMenu/FormSignup';

import CurrentUser from '@/components/mixins/CurrentUser';

import { t } from '@/store/modules/homeDrushim/constantsContent';

import { isArray } from 'lodash';
import OtpDialog from '@/components/OTP/OtpDialog';

export default {
  name: 'Userlogin',
  mixins: [CurrentUser],
  components: {
    FormLogin,
    FormSignup,
    OtpDialog
  },

  data() {
    return {
      menu: false,
      showStar: true,
      showStar2: false,
      showStar3: false,

      Popover: {
        title: t('titles.personalAreaConnect'),
        titleLogged: t('titles.personalAreaTitle'),
        recruiterBtnTxt: t('titles.recruiterTitle'),
        userBtnTxt: t('titles.lookingForJob'),
        userLoginMenu: t('titles.userLoginMenu'),
        userLoggedinMenu: t('titles.userLoggedinMenu')
      }
    };
  },

  computed: {
    adminUrl() {
      return process.env.adminUrl;
    },
    myBoardUrl() {
      if (!isArray(this.ActiveAgents) || !this.ActiveAgents.length) {
        return `/personal/myboard.aspx`;
      } else {
        let agentcode = this.ActiveAgents[0].AgentCode;
        return `/personal/myboard.aspx?agentscodes=${agentcode}`;
      }
    },
    smartLink() {
      if (this.CurrentUser && this.NumberOfAgents.length > 0) {
        return '/personal/smartalertsnotification/';
      } else {
        return '/smartalerts.aspx';
      }
    },
    /**
     * @isLoggedIn - check if user is logged in
     * @userName - received user name for display if the user logged in
     */

    userLinks() {
      return this.$store.getters.UserSectionResultModel;
    },

    iconText() {
      return this.CurrentUser
        ? this.CurrentUser.FirstName
        : t('titles.enterTxt');
    },
    welcomeText() {
      return this.CurrentUser
        ? `היי  ${this.CurrentUser.FirstName} , יופי שחזרת :) `
        : '';
    }
  },
  methods: {
    ...mapActions({
      login: 'login',
      clearJobBasket: 'clearJobBasket'
    }),

    async logout() {
      this.$toast.show('...יציאה');
      await this.$auth.logout();
      await this.$cookies.remove('drushimJobs');
      await this.clearJobBasket();

      window.location = '/';
    },
    closeMenu() {
      this.showStar = true;
      this.menu = false;
      this.showStar2 = false;
      this.showStar3 = false;
    }
  },

  beforeDestroy() {
    this.$nuxt.$off('hasEmail');
  }
};
</script>


<style lang="scss" scoped>
#user-menu-wrapper:hover * {
  color: #3e4a54;
  &.v-icon:before {
    color: #3e4a54 !important;
  }
}

.login-btn {
  display: flex;
  text-decoration: none;
  text-align: center;
  color: #363636;
  padding: 18px 8px 10px;
  height: 17px;
  font-size: 15px;
  width: 135px;
  font-weight: 400;
}

.v-btn__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
  color: #ff7100;
  transform: translateY(5px) !important;
  place-content: flex-end;
}

.login-btn .v-badge {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.icon-user {
  font-size: 25px;
}

.icon-user:before {
  font-size: 20px;
}

.v-menu__content {
  background: #fff;
  padding: 15px;
  width: 350px;
  z-index: 100;
  border-radius: 5px;
  overflow: visible;
  contain: unset;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0) !important;
}

.v-card {
  box-shadow: none;
}

.v-list__tile {
  height: 30px !important;
}

.theme--light.v-sheet {
  background-color: #fff;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  margin: 0 auto;
}

.v-btn:focus:before {
  background-color: transparent;
}

#user-menu .login-menu-hdr {
  border-bottom: 3px solid red;
}

.looking-btn,
.recruiter-btn {
  font-size: 14px;
  border-radius: 5px;
  padding: 10px 25px;
  width: 140px;
  border-color: #f6f7f9;
}

.looking-btn.selected-looking {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.recruiter-btn.selected-recruiter {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.looking-btn.selected-looking:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: $primary transparent transparent transparent;
  top: 42px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.recruiter-btn.selected-recruiter:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: $primary transparent transparent transparent;
  top: 42px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.password-recover {
  text-align: left;
  transform: translateY(-25px);
  color: #000;
}
.login-error {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  transform: translateY(-25px);
}

.logged-in-menu .flex {
  border-bottom: 1px solid rgba(255, 113, 0, 0.19);
}

.logged-in-menu p {
  padding: 5px 0;
}

.login-btn .login-text {
  text-transform: none;
  width: 64px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #363636;

  text-indent: 4px;

  font-size: 15px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: right;
}
.login-btn .user-icon {
  background-image: url('~assets/23/usericon.svg');
  background-position: center center;
  background-color: #eee;
  background-repeat: no-repeat;
  padding: 19px;
  border-radius: 100px;
  display: block;
}

@media screen and (max-width: 1450px) {
  .login-btn {
    width: 125px;
  }
}
@media screen and (max-width: 1280px) {
  .login-btn {
    font-size: 15px;
  }

  .btn-text {
    font-size: 15px;
  }

  .login-menu-wrapper:before,
  .login-menu-wrapper:after {
    left: 115px;
    top: -11px;
  }
}

@media screen and (max-width: 968px) {
  .btn-text.login-text {
    font-size: 11px;
    text-transform: none;
    width: 45px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: none !important;
  }

  .login-menu-wrapper:before,
  .login-menu-wrapper:after {
    left: 140px;
    top: -11px;
  }
}

@media screen and (max-width: 968px) {
  .login-btn {
    width: auto !important;
    min-width: auto !important;
  }
}
@media screen and (max-width: 768px) {
  .v-menu__content {
    margin-top: 1px;
  }

  .login-menu-wrapper:before,
  .login-menu-wrapper:after {
    left: 140px;
  }
  .login-btn {
    margin-top: 5px;
    width: auto;
  }
}
@media screen and (max-width: 600px) {
  .login-btn .user-icon {
    background-image: url('~assets/23/usericon.png');
    background-position: center center;
    background-color: transparent;
    margin-bottom: 5px;
  }

  .login-menu-wrapper:before,
  .login-menu-wrapper:after {
    left: 60px;
  }

  .v-menu__content {
    background: #fff;
    padding: 3px;
    width: 100% !important;
    top: 0 !important;
    left: 0 !important;
    height: 100% !important;
    position: fixed;
    overflow-y: auto;
    max-width: inherit;
  }

  input {
    font-size: 12px;
  }

  .login-menu-wrapper .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    padding: 2px;
  }

  .looking-btn,
  .recruiter-btn {
    font-size: 12px;
    padding: 0 0;
    width: 100px;
  }
}
@media screen and (max-width: 400px) {
  .theme--light.v-sheet {
    width: 100%;
  }
}
</style>
